import service from '@/utils/server';

const modName = '/int/face/driverFaceRecord/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/int/face/driverFaceRecord/api/index.js